import { render, staticRenderFns } from "./StrokeOrder.vue?vue&type=template&id=3d8e1671&"
import script from "./StrokeOrder.vue?vue&type=script&lang=js&"
export * from "./StrokeOrder.vue?vue&type=script&lang=js&"
import style0 from "./StrokeOrder.vue?vue&type=style&index=0&id=3d8e1671&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports